<lib-page-layout>
  <lib-title-navbar pageHeader title="Poleć znajomego!"></lib-title-navbar>
  <div class="or-mt-64-px or-px-20-px">
    <div class="or-head-xxl or-text-align-center">
      Poleć ORLIKFY<br />
      i zdobywaj nagrody!
    </div>
    <div class="or-text-xl or-text-align-center or-mt-28-px">
      Rejestrując nowe konto w Orlikfy wykorzystując poniższy kod, Ty i Twój znajomy otrzymacie punkty, które możecie
      wymienić na nagrody!
    </div>
    <div class="or-text-md or-text-align-center or-mt-12-px">Kod można wpisać podczas edycji profilu.</div>

    @if (referralCode(); as code) {
      <div class="or-d-flex or-flex-col or-w-100-pc or-text-align-center">
        <div class="or-head-md or-mt-48-px">Twój indywidualny kod:</div>
        <div (click)="copy()" class="or-d-flex or-justify-content-center or-align-items-center or-mt-12-px input-style">
          <div class="or-head-xl or-mr-12-px or-text-transform-uppercase letter-spacing-6-px">{{ code }}</div>
          <or-icon name="copy" size="m" class="or-color-main-1" />
        </div>
      </div>
    }
  </div>
</lib-page-layout>
